// © Microsoft Corporation. All rights reserved.

/**
 * Prefix that all flights for peregrine will use
 */
const peregrineFlightPrefix = "prg-";

/**
 * Goes through the array of flights that is given and will filter out any flight that doesn't start with
 * prg-. It then sorts them and returns a new string[].
 * @param flights Array of flights that we will filter through and return only the peregrine
 * @returns specific flights
 */
export function getPeregrineFlights(flights: string[]): string[] {
    if (!flights || flights.length === 0) {
        return flights;
    }

    const cleanedUpFlights = [];
    flights.forEach((item) => {
        const lowercaseItem = item.toLocaleLowerCase().trim();
        // Including specific 1s- prefix to bypass flightID regards OneService's bing.news backfill. Will fill bug to track/remove this.
        if (lowercaseItem.startsWith(peregrineFlightPrefix) || lowercaseItem.startsWith("1s-")) {
            cleanedUpFlights.push(lowercaseItem);
        }
    });

    return cleanedUpFlights.sort();
}